import { ChangeDetectorRef, Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EmailConfigCreateRequestDTO, EmailConfigDeleteRequestDTO, EmailConfigDTO, EmailConfigReadAllPaginatedRequestDTO, EmailConfigReadByIdRequestDTO, EmailConfigUpdatePasswordRequestDTO, EmailConfigUpdateRequestDTO } from './email-config.interface';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { environment } from 'src/environments/environment';
import { EmailConfigService } from './email-config.service';
import { GenericListUicService } from 'src/app/Common/UICServices/ListUIC/list-uic.service';
import { GenericFormUICService } from 'src/app/Common/UICServices/FormUIC/form-uic.service';
import { GenericListDataReadAllPaginatedRequestDTO, GenericListUICDTO, GenericListUICReadByTenantIdRequestDTO } from 'src/app/Common/UICServices/ListUIC/list-uic.interface';
import { GenericFormUICDTO, GenericFormUICReadByTenantIdRequestDTO } from 'src/app/Common/UICServices/FormUIC/form-uic.interface';
import { ColorColumns } from 'src/app/Shared/color-table/color-table.interface';
import { ConfirmmodalserviceService } from 'src/app/Shared/confirm-delete-modal/confirmmodalservice.service';
import { UICMasterType } from 'src/app/Common/UICServices/uic.enum';
import { UicFormComponent } from 'src/app/Shared/uic-form/uic-form.component';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationMaster_CreateRequestDTO } from '../history/history.interface';
import { HistoryService } from '../history/history.service';

@Component({
  selector: 'app-email-config',
  templateUrl: './email-config.component.html',
  styleUrls: ['./email-config.component.css']
})
export class EmailConfigComponent implements OnInit {
  modalService = inject(NgbModal)
  historyService = inject(HistoryService);

  isEditMode = false;
  gListUICService = inject(GenericListUicService);
  gFormUICService = inject(GenericFormUICService);
  gListUIC: GenericListUICDTO[] = []
  gFormUIC: GenericFormUICDTO[] = []
  tableCol: ColorColumns[] = []
  UicFormComponent!: UicFormComponent;
  router = inject(Router);
  activatedRoute = inject(ActivatedRoute)


  addEmailConfigFormModal!: NgbModalRef;
  User = inject(UserLoginService).User();
  emailConfigService = inject(EmailConfigService);
  emailConfigList: EmailConfigDTO[] = [];
  sendTo = new FormControl('',[Validators.required]);
  isLoading: boolean = false;
  showEmailPassword = false;
  confirmModal = inject(ConfirmmodalserviceService);

  @ViewChild('resetEmailPasswordModalContent', { static: false }) resetEmailPasswordModalContent!: ElementRef;
  resetEmailPasswordModal!: NgbModalRef
  emailConfigForm = new FormGroup({})
  searchText: string = '';

  resetEmailPasswordForm = new FormGroup({
    emailConfigId: new FormControl(0),
    eName: new FormControl(''),
    eFrom: new FormControl(''),
    newPassword: new FormControl('', [Validators.required, Validators.minLength(6)]),
    isActive: new FormControl(0),
    actionUser: new FormControl('')
  });

  searchForm = new FormGroup({
    whereClause: new FormControl('')
  })




  ngOnInit(): void {
    this.isLoading = true;
    this.GetTableUI()
    this.GetFormUI()

  }

  ReadAllDTO: GenericListDataReadAllPaginatedRequestDTO = {
    whereClause: '',
    orderByClause: '',
    pageSize: 10,
    pageNo: 1,
    rowNum: 0,
    totalCount: 0,
    masterType: UICMasterType.EmailConfigData,
    tenantId: this.User.companyId,
    tenantBranchId: this.User.loggedInBranchId,
  }

  getFormControl(controlName: string) {
    return this.emailConfigForm.get(controlName) as FormControl
  }

  GetTableUI() {
    let data: GenericListUICReadByTenantIdRequestDTO = {
      masterType: UICMasterType.EmailConfigList,
      tenantId: this.User.companyId
    }
    this.gListUICService.GenericListUIC_ReadByTenantId(data).subscribe(res => {

      this.gListUIC = res.items

      this.getEmailConfigList(this.ReadAllDTO)
    })
  }


  GetFormUI() {
    let data: GenericFormUICReadByTenantIdRequestDTO = {
      masterType: UICMasterType.EmailConfigForm,
      tenantId: this.User.companyId
    }
    this.gFormUICService.GenericFormUIC_ReadByTenantId(data).subscribe(res => {
      this.gFormUIC = res.items;
    })
  }


  getEmailConfigList(r: GenericListDataReadAllPaginatedRequestDTO) {
    this.isLoading = true;
    const searchText = this.searchForm.controls.whereClause.value?.trim() || '';

    let whereClause = '';
    if (searchText) {
      whereClause = `(INAME LIKE ''%${searchText}%'' OR IFROM LIKE ''%${searchText}%'')`
      r.whereClause = whereClause;
    }
    // if (searchText) {
    //   whereClause = `(iName LIKE ''%${searchText}%'' OR iDesc LIKE ''%${searchText}%'' OR iHost LIKE ''%${searchText}%'' OR iPort LIKE ''%${searchText}%'' OR iFrom LIKE ''%${searchText}%'' )`;
    //   r.whereClause = whereClause;
    // }

    this.gListUICService.GenericListData_ReadAllPaginated(r).subscribe({
      next: (res: any) => {
        this.emailConfigList = res;
        this.isLoading = false;
      },
      error: (err: any) => {
        console.error('Error fetching email data:', err);
        this.isLoading = false;
      }
    })
  }

  openEmailConfigForm() {
    // this.isEditMode = false;

    this.addEmailConfigFormModal = this.modalService.open(UicFormComponent, { size: 'lg', backdrop: 'static' });
    this.UicFormComponent = this.addEmailConfigFormModal.componentInstance as UicFormComponent;
    this.UicFormComponent.modalHeader = 'Create Email Config';
    this.UicFormComponent.gFormGroup = new FormGroup({})
    this.UicFormComponent.gFormUIC = this.gFormUIC
    this.UicFormComponent.ReadyUICForm();


    this.UicFormComponent.onSubmitEvent.subscribe(res => {
      this.submitEmailConfigForm()

    })

    this.UicFormComponent.onCloseEvent.subscribe(res => {
      this.addEmailConfigFormModal.close()
    })

  }

  submitEmailConfigForm() {
    // this.emailConfigForm.markAllAsTouched();
    this.UicFormComponent.gFormGroup.markAllAsTouched();

    if(this.UicFormComponent.gFormGroup.invalid){
      return ;
    }


    if (this.UicFormComponent.gFormGroup.valid) {
      const formValues = this.UicFormComponent.gFormGroup.getRawValue() as Partial<EmailConfigUpdateRequestDTO> & { companyId?: number; branchId?: number }
      this.isLoading = true
      this.UicFormComponent.isSubmitting = true

      if (formValues.emailConfigId && formValues.emailConfigId !== 0) {
        let data: EmailConfigUpdateRequestDTO = {
          emailConfigId: formValues.emailConfigId,
          tenantId: formValues.tenantId ?? formValues.companyId ?? this.User.companyId,
          tenantBranchId: formValues.tenantBranchId ?? formValues.branchId ?? this.User.loggedInBranchId,
          softwareId: formValues.softwareId ?? parseInt(environment.SoftwareId),
          iName: formValues.iName ?? "",
          iDesc: formValues.iDesc ?? "",
          iHost: formValues.iHost ?? "",
          iPort: formValues.iPort ?? "",
          iFrom: formValues.iFrom ?? "",
          iPassword: formValues.iPassword ?? "",
          otherDetail1: formValues.otherDetail1 ?? "",
          otherDetail2: formValues.otherDetail2 ?? "",
          otherDetail3: formValues.otherDetail3 ?? "",
          otherDetail4: formValues.otherDetail4 ?? "",
          otherDetail5: formValues.otherDetail5 ?? "",
          iEnableSsl: Number(formValues.iEnableSsl) ?? 0,
          isBodyHtml: Number(formValues.isBodyHtml) ?? 0,
          isActive: 1,
          actionUser: this.User.userId.toString()
        }
        this.emailConfigService.EmailConfig_update(data).subscribe({
          next: (res: any) => {
            this.UicFormComponent.isSubmitting = false
            this.getEmailConfigList(this.ReadAllDTO)
            this.addEmailConfigFormModal.close();
            this.isLoading = false;
          },
          error: (err: any) => {
            this.UicFormComponent.isSubmitting = false
            console.error('Error fetching email data:', err);
            this.addEmailConfigFormModal.close();
            this.isLoading = false;
          }
        })

      } else {

        let data: EmailConfigCreateRequestDTO = {
          tenantId: this.User.companyId,
          tenantBranchId: this.User.loggedInBranchId,
          softwareId: parseInt(environment.SoftwareId),
          iName: formValues.iName ?? "",
          iDesc: formValues.iDesc ?? "",
          iHost: formValues.iHost ?? "",
          iPort: formValues.iPort ?? "",
          iFrom: formValues.iFrom ?? "",
          iPassword: formValues.iPassword ?? "",
          otherDetail1: formValues.otherDetail1 ?? "",
          otherDetail2: formValues.otherDetail2 ?? "",
          otherDetail3: formValues.otherDetail3 ?? "",
          otherDetail4: formValues.otherDetail4 ?? "",
          otherDetail5: formValues.otherDetail5 ?? "",
          iEnableSsl: Number(formValues.iEnableSsl) ?? 0,
          isBodyHtml: Number(formValues.isBodyHtml) ?? 0,
          actionUser: this.User.userId.toString()
        }
        console.log(data)

        this.emailConfigService.EmailConfig_create(data).subscribe((res) => {
          this.UicFormComponent.isSubmitting = false
          this.isLoading = false;
          this.getEmailConfigList(this.ReadAllDTO);
          this.addEmailConfigFormModal.close();
        })
      }
    }
  }




  handleActionClick(event: { actionName: string; rowData: EmailConfigDTO; }) {
    const { actionName, rowData } = event

    if (actionName === 'Edit') {

      this.isEditMode = true;


      this.addEmailConfigFormModal = this.modalService.open(UicFormComponent, { size: 'lg', backdrop: 'static' });
      this.UicFormComponent = this.addEmailConfigFormModal.componentInstance as UicFormComponent;
      this.UicFormComponent.modalHeader = 'Create Email Config';
      this.UicFormComponent.gFormGroup = this.emailConfigForm
      this.UicFormComponent.gFormUIC = this.gFormUIC
      this.UicFormComponent.ReadyUICForm();
      this.UicFormComponent.patchValueToFormGroup(rowData)


      this.UicFormComponent.onSubmitEvent.subscribe(res => {
        this.submitEmailConfigForm()

      })

      this.UicFormComponent.onCloseEvent.subscribe(res => {
        this.addEmailConfigFormModal.close()
      })



    }
    else if (actionName === 'Delete') {
      this.confirmModal.openDeleteModal(rowData.iName!, rowData).subscribe(res => {
        if (res) {
          let data: EmailConfigDeleteRequestDTO = {
            emailConfigId: rowData.emailConfigId,
            tenantId: rowData.tenantId ?? this.User.companyId,
            tenantBranchId: rowData.tenantBranchId ?? this.User.loggedInBranchId,
            actionUser: this.User.userId.toString()
          }
          this.deleteEmailConfig(data);
        }

      })



    }
    else if (actionName === 'Reset Password') {
      const data: EmailConfigReadByIdRequestDTO = {
        emailConfigId: rowData.emailConfigId,
        tenantId: rowData.tenantId ?? this.User.companyId,
        tenantBranchId: rowData.tenantBranchId ?? this.User.loggedInBranchId,
      }
      this.openResetEmailPasswordModal(data)
    }
  }


  openResetEmailPasswordModal(data: EmailConfigReadByIdRequestDTO) {
    this.resetEmailPasswordForm.reset();
    this.emailConfigService.EmailConfig_readById(data).subscribe((res) => {
      if (res) {
        this.resetEmailPasswordForm.patchValue({
          emailConfigId: res.emailConfigId,
          eName: res.iName,

          eFrom: res.iFrom,
          isActive: res.isActive,
          actionUser: this.User.userId.toString(), // from logged-in user context
          newPassword: ''
        });
      }

      // Now open the modal AFTER data is patched
      this.resetEmailPasswordModal = this.modalService.open(this.resetEmailPasswordModalContent);

    });
  }


  resetEmailPassword() {
    this.resetEmailPasswordForm.markAllAsTouched();
    if (this.resetEmailPasswordForm.invalid) return;

    if (this.resetEmailPasswordForm.valid) {
      const newPassword = this.resetEmailPasswordForm.value.newPassword;

      const updatePayload: EmailConfigUpdatePasswordRequestDTO = {

        emailConfigId: this.resetEmailPasswordForm.value.emailConfigId!,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId,
        newPassword: newPassword!,
        actionUser: this.User.userId.toString(),
      };

      this.emailConfigService.EmailConfig_updatePassword(updatePayload).subscribe({
        next: (res) => {
          console.log('Password update response:', res);
          this.resetEmailPasswordModal.close();
          this.getEmailConfigList(this.ReadAllDTO);
        },
        error: (err) => {
          console.error('Password update failed:', err);
        }
      }
      );
    }
  }

  deleteEmailConfig(data: EmailConfigDeleteRequestDTO) {
    this.emailConfigService.EmailConfig_delete(data).subscribe((res) => {

      this.getEmailConfigList(this.ReadAllDTO);
    })
  }

  handlePageSizeChange(event: { currentPage: number; pageSize: number; }) {
    const { currentPage, pageSize } = event

    this.ReadAllDTO = {
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      pageNo: currentPage,
      pageSize: pageSize,

      whereClause: '',
      orderByClause: '',
      rowNum: 0,
      totalCount: 0,
      masterType: UICMasterType.EmailConfigData,


    }
    this.getEmailConfigList(this.ReadAllDTO)

  }

  loadData() {

    const searchValue = this.searchText?.trim() ?? '';
  
    this.ReadAllDTO = {
      whereClause: searchValue ? `(INAME LIKE ''%${searchValue}%'' OR IFROM LIKE ''%${searchValue}%'')` : '',
      orderByClause: '',
      pageSize: 10,
      pageNo: 1,
      rowNum: 0,
      totalCount: 0,
      masterType: UICMasterType.EmailConfigData,
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
    };
    this.getEmailConfigList(this.ReadAllDTO)
  }
  clearSearchAndReload() {
    this.searchText = '';
    this.searchForm.controls.whereClause.setValue('');
    this.ReadAllDTO = {
      whereClause: '',
      orderByClause: '',
      pageSize: 10,
      pageNo: 1,
      rowNum: 0,
      totalCount: 0,
      masterType: UICMasterType.EmailConfigData,
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
    };

    this.getEmailConfigList(this.ReadAllDTO);
  }

  get whereClauseControl(): FormControl {
    return this.searchForm.get('whereClause') as FormControl;
  }
  selectedTab: string = 'Grid';

  tabs = [
    {
      tabName: 'Tabular',
      tabIcon: 'fa fa-bars',
    },
    {
      tabName: 'Grid',
      tabIcon: 'fa fa-th',
    }
  ]

  onTabSelect(arg0: string) {
    this.selectedTab = arg0
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { view: this.selectedTab },
      queryParamsHandling: 'merge', // Keeps existing query params if needed
      replaceUrl: true              // Prevents extra history entry
    });
  }


  sendTestEmail(emailConfig: EmailConfigDTO) {

    this.sendTo.markAllAsTouched();
    if (this.sendTo.invalid) {
      return;
    }
    emailConfig.isLoading = true;
    const data: NotificationMaster_CreateRequestDTO = {
      alertConfigId: Number(emailConfig.emailConfigId),
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      softwareId: 1,
      nType: 'Email',
      nSubject: "Testing EMail Config - " + emailConfig.iName,
      nContent: "This is a test email to verify the email configuration settings.",
      nTo: this.sendTo.value ?? "",
      nCc: " ",
      nBcc: " ",
      nStatus: 'Pending',
      remarks: '',
      scheduledDate: new Date().toISOString(),
      attachmentPath: '',
      retryCount: 0,
      retryDate: null,
      postSendDataSourceType: "",
      postSendDataSourceDef: "",
      dbConnId: 1,
      actionUser: this.User.userId.toString()
    };

    this.historyService.notificationMaster_Create(data).subscribe({
      next: () => {
      emailConfig.isLoading = false;
       this.confirmModal.openSwalModal("","Test email has been queued for sending. Please check the recipient inbox to verify the configuration.",'success');

      }
    });
  }
}
